import jQuery from 'jquery';
import * as Popper from "@popperjs/core"
import Modal from 'bootstrap'
import Blazy from 'blazy'

import {settings} from './variables.js';

var baseUrl = settings.apiBaseUrl;

require('./utils.js')
require('./actions.js')
require('./facets.js')
require('./gallery_navigation.js')

;(function() {
    var bLazy = new Blazy()
})()

getDropdowns()
getCollapses()
getHoversMenu()
collapseCatalogChildren()
renderTailGallery()
collapseFacets()
galleryNavigations()

window.addEventListener('resize', () => {
  getHoversMenu()
})
